export class RetentionRow {
  public MembershipLevel: string;
  public AccountsBilled: number;
  public AccountsPaid: number;
  public MemberRetention: number;
  public AmountBilled: number;
  public AmountPaid: number;
  public InvestmentRetention: number;

  public constructor() {
    this.MembershipLevel = '';
    this.AccountsBilled = 0;
    this.AccountsPaid = 0;
    this.MemberRetention = 0;
    this.AmountBilled = 0;
    this.AmountPaid = 0;
    this.InvestmentRetention = 0;
  }
}
